enum PageMode {
	All = "all",
	Odd = "odd",
	Even = "even"
}

export default PageMode;